// extracted by mini-css-extract-plugin
module.exports = {"root":"Contacts_root__3qJXd","line":"Contacts_line__2vYio","icon":"Contacts_icon__Ol-he","text":"Contacts_text__2DfpV","hours":"Contacts_hours__ZSKO4","day":"Contacts_day__1ucW1"};